<template>
  <div>
    <div v-if="value" class="table_label">
      <span>{{ text }}</span>
      <span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    labelKey: { type: String, default: '' },
    funcID: { type: String, default: '' },
    global: { type: Boolean, default: false },
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      const funcID = this.global ? 'INDEX' : ''
      const labelKey = [funcID, this.labelKey].filter(Boolean).join('.')
      return this.$l(labelKey) || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.table_label {
  span:empty {
    display: none;
  }
  span:first-child {
    &::after {
      content: '：';
    }
  }
}
</style>
